import { render, staticRenderFns } from "./DeskToolbar.vue?vue&type=template&id=5992d268&scoped=true&"
import script from "./DeskToolbar.vue?vue&type=script&lang=js&"
export * from "./DeskToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DeskToolbar.vue?vue&type=style&index=0&id=5992d268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5992d268",
  null
  
)

export default component.exports